module.exports = __webpack_public_path__ + "img/wen.590fbdc7.png";